import React, { Fragment, useState, useEffect } from 'react';

import moneyIconGreen from 'assets/img/icons/money.svg';
import moneyIconGrey from 'assets/img/icons/money-grey.svg';

import HireModal from '../../../OrderModals/HireModal';
import CancelQuoteModal from '../../../OrderModals/CancelQuoteModal';
import AuthorizeModal from '../../../OrderModals/AuthorizeModal';

import { gaSendEvent } from '../../../../../../utils/analytics';

import {
  InfoBox,
  MoneyIcon,
  OrderTitle,
  OrderText,
  OrderLeft,
  InfoText,
  OrderPrice,
  LinkOrder,
  DescriptionInput,
  OrderLine,
  PriceText,
  HireBtn,
  NotAmountText,
} from '../styles';

const PaymentInfoCard = ({
  validate, taskQuoteProDetail, taskDetail, onFinish,
}) => {
  const [hireModalIsOpen, setHireModalIsOpen] = useState(false);
  const [cancelModalIsOpen, setCancelModalIsOpen] = useState(false);
  const [authorizeModalIsOpen, setAuthorizeModalIsOpen] = useState(false);
  const [newAmount, setNewAmount] = useState(null);
  const [isDescriptionOrder, setIsDescriptionOrder] = useState(false);

  useEffect(() => {
    setNewAmount(taskQuoteProDetail.new_amount);
  }, [taskQuoteProDetail]);

  const getPaymentText = (status) => {
    switch (status) {
      case 'open':
        if (newAmount) {
          return 'Valor Orçado com alteração';
        }
        return 'Enviou orçamento';
      case 'hired':
        if (newAmount) {
          return 'Valor Fechado com alteração';
        }
        return 'Valor Fechado';
      case 'charged':
        if (newAmount) {
          return 'Valor Fechado com alteração';
        }
        return 'Valor Fechado';
      case 'done':
        if (newAmount) {
          return 'Valor Fechado com alteração';
        }
      case 'paid':
        return 'Valor Pago';
      default:
        return '';
    }
  };

  const formatAmount = (amount) => {
    if (amount && amount > 0) {
      return amount
        .toLocaleString('pt-BR', {
          minimumFractionDigits: 2,
          style: 'currency',
          currency: 'BRL',
        })
        .replace('R$', '')
        .split(',');
    }
    return '--';
  };

  const openHireTask = () => {
    gaSendEvent('contratar', 'detalhes_pedido', `${taskDetail.id}`);
    setHireModalIsOpen(!hireModalIsOpen);
  };

  const openCancelTask = () => {
    gaSendEvent('cancelar_contratacao', 'detalhes_pedido', `${taskDetail.id}`);
    setCancelModalIsOpen(!cancelModalIsOpen);
  };

  const openAuthorizeTask = () => {
    gaSendEvent('autorizar_contratacao', 'detalhes_pedido', `${taskDetail.id}`);
    setAuthorizeModalIsOpen(!authorizeModalIsOpen);
  };

  const timeReceiveOrder = () => {
    const dateSub = new Date();
    dateSub.setTime(
      new Date(taskQuoteProDetail.created).getTime() - new Date(taskDetail.created).getTime(),
    );

    const minutesFull = Math.floor(dateSub.getTime() / 60000);

    const day = parseInt(minutesFull / (24 * 60), 10);
    const hour = parseInt((minutesFull % (24 * 60)) / 60, 10);
    const minutes = (minutesFull % (24 * 60)) % 60;

    if (day >= 1) {
      if (hour >= 1) {
        if (day === 1) {
          return ` ${day} dia e ${hour} ${hour === 1 ? 'hora ' : 'horas '} `;
        }
        return ` ${day} dias e ${hour} ${hour === 1 ? 'hora ' : 'horas '}`;
      }
      if (day === 1) {
        return ` ${day} dia e ${minutes} ${minutes === 1 ? 'minuto ' : 'minutos '} `;
      }
      return ` ${day} dias e ${minutes} ${minutes === 1 ? 'minuto ' : 'minutos '} `;
    }
    if (hour >= 1) {
      if (hour === 1) {
        return ` ${hour} hora e ${minutes} ${minutes === 1 ? 'minuto ' : 'minutos '} `;
      }
      return ` ${hour} horas e ${minutes} ${minutes === 1 ? 'minuto ' : 'minutos '} `;
    }
    if (minutes === 1) {
      return ` ${minutes} minuto `;
    }
    return ` ${minutes} minutos `;
  };

  return (
    <InfoBox>
      <MoneyIcon amount={validate.amount}>
        <img src={validate.amount ? moneyIconGreen : moneyIconGrey} alt="Money Icon" />
      </MoneyIcon>
      {validate.amount ? (
        <Fragment>
          <OrderTitle>{getPaymentText(taskDetail.status)}</OrderTitle>
          <OrderText>
            <p>
              Recebido em
              <b>{timeReceiveOrder()}</b>
              <br />
              após o pedido
            </p>
          </OrderText>
          {isDescriptionOrder ? (
            <DescriptionInput
              disabled
              defaultValue={taskQuoteProDetail.task_description || 'Nenhuma descrição do serviço'}
            />
          ) : (
            <OrderPrice>
              <OrderLine light={false}>
                <OrderLeft>
                  <p>Mão de Obra</p>
                </OrderLeft>
                <PriceText>
                  <p>
                    {taskQuoteProDetail.task_price ? (
                      <Fragment>
                        <small>{'R$ '}</small>
                        <strong>{formatAmount(taskQuoteProDetail.task_price)[0]}</strong>
                        ,
                        <small>{formatAmount(taskQuoteProDetail.task_price)[1]}</small>
                      </Fragment>
                    ) : (
                      '--'
                    )}
                  </p>
                </PriceText>
              </OrderLine>
              <OrderLine light={false}>
                <OrderLeft>
                  <p>Materiais</p>
                </OrderLeft>
                <PriceText>
                  <p>
                    {taskQuoteProDetail.material_price ? (
                      <Fragment>
                        <small>{'R$ '}</small>
                        <strong>{formatAmount(taskQuoteProDetail.material_price)[0]}</strong>
                        ,
                        <small>{formatAmount(taskQuoteProDetail.material_price)[1]}</small>
                      </Fragment>
                    ) : (
                      '--'
                    )}
                  </p>
                </PriceText>
              </OrderLine>
              <OrderLine light>
                <OrderLeft isBold>
                  <p>Total</p>
                </OrderLeft>
                <PriceText isBold larger>
                  <p>
                    <small>R$</small>

                    {newAmount ? (
                      <Fragment>
                        <small>{'R$ '}</small>
                        <strong>{formatAmount(newAmount)[0]}</strong>
                        <small>
                          ,
                          {formatAmount(newAmount)[1]}
                        </small>
                      </Fragment>
                    ) : (
                      <Fragment>
                        <strong>{formatAmount(taskQuoteProDetail.price)[0]}</strong>
                        <small>
                          ,
                          {formatAmount(taskQuoteProDetail.price)[1]}
                        </small>
                      </Fragment>
                    )}
                  </p>
                </PriceText>
              </OrderLine>
            </OrderPrice>
          )}
        </Fragment>
      ) : (
        <Fragment>
          <OrderTitle notAmount>ORÇAMENTO</OrderTitle>
          <NotAmountText notAmount>
            <p>
              O Profissional
              <b> ainda não enviou o orçamento. </b>
              Responda as dúvidas do profissional e ele poderá estimar um orçamento.
            </p>
          </NotAmountText>
        </Fragment>
      )}
      {validate.amount && (
        <LinkOrder>
          <button type="button" onClick={() => setIsDescriptionOrder(!isDescriptionOrder)}>
            {isDescriptionOrder ? 'Ver orçamento' : 'Descrição detalhada do serviço'}
          </button>
        </LinkOrder>
      )}
      {taskDetail.status === 'open' && !taskQuoteProDetail.selected && (
        <HireBtn
          backgroundColor={validate.amount ? 'primary' : 'greyLight'}
          onClick={() => (validate.amount ? openHireTask() : null)}
          cursor={validate.amount ? 'pointer' : ''}
        >
          Contratar
        </HireBtn>
      )}
      {taskDetail.status === 'hired' && taskQuoteProDetail.selected && (
        <HireBtn backgroundColor="red" onClick={() => openCancelTask()} cursor="pointer">
          Cancelar Contratação
        </HireBtn>
      )}

      {/* {taskDetail.status === 'open' && !taskQuoteProDetail.approved && taskDetail.from_tenant && (
        <HireBtn
          backgroundColor={validate.amount ? 'primary' : 'greyLight'}
          onClick={() => (validate.amount ? openAuthorizeTask() : null)}
          cursor={validate.amount ? 'pointer' : ''}
        >
          Autorizar
        </HireBtn>
      )} */}
      <HireModal hireModalIsOpen={hireModalIsOpen} setHireModalIsOpen={setHireModalIsOpen} />

      <CancelQuoteModal
        cancelModalIsOpen={cancelModalIsOpen}
        setCancelModalIsOpen={setCancelModalIsOpen}
        taskQuoteProDetail={taskQuoteProDetail}
        taskDetail={taskDetail}
      />

      <AuthorizeModal
        isOpen={authorizeModalIsOpen && !taskQuoteProDetail.approved}
        toggle={() => setAuthorizeModalIsOpen(false)}
        onFinish={onFinish}
        taskQuoteProDetail={taskQuoteProDetail}
        taskDetail={taskDetail}
      />
    </InfoBox>
  );
};

export default PaymentInfoCard;
